import React from 'react';
import { useTheme } from '@emotion/react';
import { Box, Typography } from '@mui/material';

/**
 * A label, its guidance, and the control it describes.
 *
 * For controls that are not a text input — a segmented control, a row of
 * toggleable chips — which otherwise each grew their own label markup and
 * drifted apart in size and spacing.
 *
 * The hint sits between the label and the control, not under it: it explains
 * what the choice means, and it is no use arriving after the choice has been
 * made.
 */
const Field = ({ label, hint, htmlFor, children }) => {
    const theme = useTheme();

    return (
        <Box>
            <Typography
                component="label"
                htmlFor={htmlFor}
                sx={{
                    display: 'block',
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    lineHeight: 1.4,
                    color: theme.palette.customColors.g500,
                }}
            >
                {label}
            </Typography>

            {hint && (
                <Typography sx={{
                    fontSize: '0.75rem',
                    lineHeight: 1.5,
                    color: theme.palette.customColors.g200,
                    marginTop: '0.125rem',
                    maxWidth: '68ch',
                }}>
                    {hint}
                </Typography>
            )}

            <Box sx={{ marginTop: '0.5rem' }}>
                {children}
            </Box>
        </Box>
    );
};

export default Field;
